import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const LanguageSelector = () => {
  const [currentLanguage, setCurrentLanguage] = useState('de');
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
    { code: 'en', label: 'English', flag: '🇺🇸' }
  ];

  useEffect(() => {
    // Check localStorage for saved language preference
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage && languages?.find(lang => lang?.code === savedLanguage)) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const handleLanguageChange = (languageCode) => {
    setCurrentLanguage(languageCode);
    localStorage.setItem('preferredLanguage', languageCode);
    setIsOpen(false);
    
    // In a real app, this would trigger a language change throughout the application
    console.log(`Language changed to: ${languageCode}`);
  };

  const currentLang = languages?.find(lang => lang?.code === currentLanguage);

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2"
      >
        <span className="text-lg">{currentLang?.flag}</span>
        <span className="text-sm">{currentLang?.label}</span>
        <Icon name="ChevronDown" size={14} />
      </Button>
      {isOpen && (
        <div className="absolute top-full left-0 mt-1 w-full bg-popover border border-border rounded-lg shadow-modal z-50">
          {languages?.map((language) => (
            <button
              key={language?.code}
              onClick={() => handleLanguageChange(language?.code)}
              className={`w-full flex items-center space-x-3 px-3 py-2 text-left hover:bg-muted transition-colors first:rounded-t-lg last:rounded-b-lg ${
                currentLanguage === language?.code ? 'bg-muted' : ''
              }`}
            >
              <span className="text-lg">{language?.flag}</span>
              <span className="text-sm text-popover-foreground">{language?.label}</span>
              {currentLanguage === language?.code && (
                <Icon name="Check" size={14} className="text-primary ml-auto" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;